import { decode } from '@googlemaps/polyline-codec';

type Props = { polyline: string; className?: string; color: string };

const PathDisplay = ({ polyline, className, color }: Props) => {
  const decodedPolyline = decode(polyline);

  const xArr = decodedPolyline.map((val) => val[0]);
  const xMin = Math.min(...xArr);
  const xMax = Math.max(...xArr);
  const yArr = decodedPolyline.map((val) => val[1]);
  const yMin = Math.min(...yArr);
  const yMax = Math.max(...yArr);

  const xRange = xMax - xMin;
  const yRange = yMax - yMin;
  const scale = 100 / Math.max(...[xRange, yRange]);

  decodedPolyline.forEach((coord) => {
    coord[0] = (coord[0] - xMin) * scale;
    coord[1] = (coord[1] - yMin) * scale;
  });

  const path = `M ${decodedPolyline
    .map((coord) => `${coord[0]}, ${coord[1]}`)
    .join(' L ')}`;

  return (
    <div className={className}>
      <svg
        height={180}
        width={320}
        viewBox="-50 -10 200 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path d={path} fill="none" stroke={color} strokeWidth="2" />
        </g>
      </svg>
    </div>
  );
};

export default PathDisplay;
